import React from "react";
import { motion } from "framer-motion";

// Reusable scroll-entrance reveal.
export const Reveal = ({ children, delay = 0, y = 20, className = "", as = "div" }) => {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-50px" }}
      transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </MotionTag>
  );
};

export const Eyebrow = ({ children, className = "" }) => (
  <span
    className={`font-mono-label text-xs uppercase tracking-[0.2em] text-[#8FA4FF] ${className}`}
  >
    {children}
  </span>
);

export default Reveal;
